import RegisterTypeSelect from './RegisterTypeSelect';

export default RegisterTypeSelect;
